import {GameModeDetail} from "../gameManager";

//
export enum GAME_MODE {
    NORMAL,//闯关模式
    DFS,//深度
    TALK_ROOM,//聊天室
    BATTLE_MODE,
    COCOS_MODE,
    FPS_GAME,
    SPEND
}

//场景类别
export enum SCENE_MODE {
    NORMAL,
    //场景
    FIRE = 0,
    //预制体
    PREFAB
}

//模式配置
const MODES: GameModeDetail[] = [
    {
        type: GAME_MODE.NORMAL,
        name: 'normalMode',
        sceneName: 'normalMode',
        sceneMode: SCENE_MODE.FIRE,
        explain: '闯关模式',
        isMainScene : true,
        lookVideCount: 0,
    },
    {
        type: GAME_MODE.DFS,
        name: 'dfsMode',
        sceneName: 'dfsMode',
        sceneMode: SCENE_MODE.FIRE,
        explain: '迷宫生成',
        lookVideCount: 0,
    },
    {
        type: GAME_MODE.TALK_ROOM,
        name: 'talkRoomMode',
        sceneName: 'talkRoomMode',
        sceneMode: SCENE_MODE.FIRE,
        explain: '聊天室',
        lookVideCount: 0,
    },
    {
        type: GAME_MODE.BATTLE_MODE,
        name: 'battleMode',
        sceneName: 'battleMode',
        sceneMode: SCENE_MODE.FIRE,
        explain: '联机对战',
        lookVideCount: 0,
        onlineGameId: 101,
    },
    {
        type: GAME_MODE.COCOS_MODE,
        name: 'cocosMode',
        sceneName: 'cocosMode',
        sceneMode: SCENE_MODE.FIRE,
        explain: '残影',
        lookVideCount: 0,
    },
    {
        type: GAME_MODE.FPS_GAME,
        name: 'fpsMode',
        sceneName: 'fpsMode',
        sceneMode: SCENE_MODE.FIRE,
        explain: '帧同步demo',
        lookVideCount: 0,
        // isMainScene: true,
        // onlineGameId: 102,
    },
    {
        type: GAME_MODE.SPEND,
        name: 'spendMode',
        sceneName: 'spendMode',
        sceneMode: SCENE_MODE.FIRE,
        explain: '闯关模式',
        lookVideCount: 0,
    },
];

export default function () {
    //
    return MODES;
}
